<template>
    <div>

        <PageBanner :title="$t('gen.page46')" />
        <FilterContent />
    </div>


</template>

<script>
import PageBanner from '../blocks/PageBanner.vue'
import FilterContent from '../blocks/FilterContent.vue'
export default {
  components: { PageBanner, FilterContent },
}
</script>
